import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      'bridge-config-field': true,
      'has-prepend-icon': _vm.hasPrependIcon
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.quickReferenceHeader'),
      "open": _vm.openHelpText,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.openHelpText = false;
      }
    }
  }, [_vm.hasHelpText ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t(_vm.helpTextKey))
    }
  }) : _vm._e()]), _vm.fieldConfig.type === 'boolean' ? [!_vm.bridgeHasValidParameters && _vm.isBrigdeHasError ? [_c(VIcon, {
    staticClass: "pr-4 mt-1",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "color": "danger"
    }
  }, [_vm._v("fal fa-exclamation-circle")])] : _vm.bridgeHasValidParametersStrict ? [_c(VIcon, {
    staticClass: "pr-4 mt-1",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "color": "success"
    }
  }, [_vm._v("fal fa-check-circle")])] : [_c(VIcon, {
    class: `mt-1 ${_vm.defaultIcon ? 'pr-4' : ''}`,
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.defaultIcon))])], _c(VSwitch, {
    staticClass: "mt-3 ml-4",
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.fieldConfig.name ? _vm.fieldConfig.name : _vm.v ? `${_vm.configKey}` : `un${_vm.configKey}`,
      "error": !_vm.bridgeHasValidParameters && _vm.isBrigdeHasError,
      "success": _vm.bridgeHasValidParametersStrict,
      "hide-details": _vm.detailsMode,
      "disabled": _vm.disabled,
      "readonly": _vm.fieldConfig.readonly,
      "autocomplete": "off",
      "inset": ""
    },
    on: {
      "change": _vm.modelChanged
    },
    model: {
      value: _vm.v,
      callback: function ($$v) {
        _vm.v = $$v;
      },
      expression: "v"
    }
  })] : _vm.fieldConfig.type === 'enum' ? [_c(VSelect, {
    class: `${_vm.fieldConfig.optional ? '' : 'required'}`,
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "error": !_vm.bridgeHasValidParameters && _vm.isBrigdeHasError,
      "success": _vm.bridgeHasValidParametersStrict,
      "items": _vm.enumItems,
      "label": _vm.fieldLabel,
      "clearable": _vm.fieldConfig.optional,
      "rules": _vm.rulesForField(_vm.fieldConfig),
      "hide-details": _vm.detailsMode,
      "disabled": _vm.disabled,
      "readonly": _vm.fieldConfig.readonly
    },
    on: {
      "change": _vm.modelChanged
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [!_vm.bridgeHasValidParameters && _vm.isBrigdeHasError ? [_c(VIcon, {
          staticClass: "pr-2",
          attrs: {
            "color": "danger"
          }
        }, [_vm._v("fal fa-exclamation-circle")])] : _vm.bridgeHasValidParametersStrict ? [_c(VIcon, {
          staticClass: "pr-2",
          attrs: {
            "color": "success"
          }
        }, [_vm._v("fal fa-check-circle")])] : [_c(VIcon, {
          class: `${_vm.defaultIcon ? 'pr-2' : ''}`
        }, [_vm._v(_vm._s(_vm.defaultIcon))])]];
      },
      proxy: true
    }]),
    model: {
      value: _vm.v,
      callback: function ($$v) {
        _vm.v = $$v;
      },
      expression: "v"
    }
  })] : !!_vm.fieldConfig.autocomplete ? [_c(VAutocomplete, {
    class: `${_vm.fieldConfig.optional ? '' : 'required'}`,
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "error": !_vm.bridgeHasValidParameters && _vm.isBrigdeHasError,
      "success": _vm.bridgeHasValidParametersStrict,
      "items": _vm.autoCompleteItems,
      "filter": (item, qt, it) => true,
      "label": _vm.fieldLabel,
      "clearable": true,
      "search-input": _vm.search,
      "rules": _vm.rulesForField(_vm.fieldConfig),
      "hide-details": _vm.detailsMode,
      "return-object": _vm.get(_vm.fieldConfig, 'autocompleteConfig.returnPlainValue') !== true,
      "disabled": _vm.disabled,
      "readonly": _vm.fieldConfig.readonly,
      "append-icon": _vm.isCreatedByTemplate ? 'fa-sitemap' : undefined
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event;
      },
      "update:search-input": function ($event) {
        _vm.search = $event;
      },
      "change": _vm.modelChanged
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [!_vm.bridgeHasValidParameters && _vm.isBrigdeHasError ? [_c(VIcon, {
          staticClass: "pr-2",
          attrs: {
            "color": "danger"
          }
        }, [_vm._v("fal fa-exclamation-circle")])] : _vm.bridgeHasValidParametersStrict ? [_c(VIcon, {
          staticClass: "pr-2",
          attrs: {
            "color": "success"
          }
        }, [_vm._v("fal fa-check-circle")])] : [_c(VIcon, {
          class: `${_vm.defaultIcon ? 'pr-2' : ''}`
        }, [_vm._v(_vm._s(_vm.defaultIcon))])]];
      },
      proxy: true
    }]),
    model: {
      value: _vm.v,
      callback: function ($$v) {
        _vm.v = $$v;
      },
      expression: "v"
    }
  })] : _vm.fieldConfigStringField === 'textarea' ? [_c(VTextarea, {
    class: `${_vm.fieldConfig.optional ? '' : 'required'}`,
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.fieldLabel,
      "error": !_vm.bridgeHasValidParameters && _vm.isBrigdeHasError,
      "success": _vm.bridgeHasValidParametersStrict,
      "hide-details": _vm.detailsMode,
      "disabled": _vm.disabled,
      "readonly": _vm.fieldConfig.readonly,
      "type": _vm.fieldConfig.stringOptions.secure && !_vm.showPassword ? 'password' : 'text',
      "rows": "4",
      "autocomplete": "off",
      "clearable": ""
    },
    on: {
      "input": _vm.modelChanged,
      "click:append": function ($event) {
        return _vm.textFieldClicked(true);
      },
      "click": function ($event) {
        return _vm.textFieldClicked();
      },
      "blur": function ($event) {
        return _vm.textFieldBlurred();
      }
    },
    model: {
      value: _vm.v,
      callback: function ($$v) {
        _vm.v = $$v;
      },
      expression: "v"
    }
  })] : _vm.fieldConfig.type === 'jsonkeyvalue' ? [_vm.emptyCustomHeaders ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "solid-icon": "",
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.initCustomHeaders();
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.addNewCustomHeaders')) + "\n    ")]) : _vm._e(), _vm._l(_vm.keyValueItems, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "json-key-value"
    }, [_c(VTextField, {
      class: `mr-6 ${_vm.fieldConfig.optional ? '' : 'required'}`,
      attrs: {
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "color": _vm.color,
        "error": !_vm.bridgeHasValidParameters && _vm.isBrigdeHasError,
        "success": _vm.bridgeHasValidParametersStrict,
        "hide-details": _vm.detailsMode,
        "disabled": _vm.disabled,
        "rows": "4",
        "autocomplete": "off",
        "clearable": "",
        "label": "Header Key"
      },
      on: {
        "input": function ($event) {
          _vm.updateKeyValuePair(index, $event, 'key'), _vm.modelChanged($event);
        },
        "click:append": function ($event) {
          return _vm.textFieldClicked(true);
        },
        "click": function ($event) {
          return _vm.textFieldClicked();
        },
        "blur": function ($event) {
          return _vm.textFieldBlurred();
        }
      },
      model: {
        value: item[0],
        callback: function ($$v) {
          _vm.$set(item, 0, $$v);
        },
        expression: "item[0]"
      }
    }), _c(VTextField, {
      class: `mr-6 ${_vm.fieldConfig.optional ? '' : 'required'}`,
      attrs: {
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "color": _vm.color,
        "error": !_vm.bridgeHasValidParameters && _vm.isBrigdeHasError,
        "success": _vm.bridgeHasValidParametersStrict,
        "hide-details": _vm.detailsMode,
        "disabled": _vm.disabled,
        "rows": "4",
        "autocomplete": "off",
        "clearable": "",
        "label": "Header Value"
      },
      on: {
        "input": function ($event) {
          _vm.updateKeyValuePair(index, $event, 'value'), _vm.modelChanged($event);
        },
        "click:append": function ($event) {
          return _vm.textFieldClicked(true);
        },
        "click": function ($event) {
          return _vm.textFieldClicked();
        },
        "blur": function ($event) {
          return _vm.textFieldBlurred();
        }
      },
      model: {
        value: item[1],
        callback: function ($$v) {
          _vm.$set(item, 1, $$v);
        },
        expression: "item[1]"
      }
    }), _c('core-button', {
      attrs: {
        "title": _vm.$i18n_t('Common.addNew'),
        "color": _vm.color,
        "x-small": _vm.dense,
        "prepend-icon": "fa-plus"
      },
      on: {
        "click": function ($event) {
          _vm.addKeyValuePair(index), _vm.modelChanged($event);
        }
      }
    }), _c('core-button', {
      attrs: {
        "title": _vm.$i18n_t('Common.delete'),
        "color": _vm.color,
        "x-small": _vm.dense,
        "prepend-icon": "fa-trash-alt"
      },
      on: {
        "click": function ($event) {
          _vm.removeKeyValuePair(index), _vm.modelChanged($event);
        }
      }
    })], 1);
  })] : [_c(VTextField, {
    class: `${_vm.fieldConfig.optional ? '' : 'required'}`,
    attrs: {
      "append-icon": _vm.textFieldAppendIcon,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.fieldLabel,
      "error": !_vm.bridgeHasValidParameters && !_vm.fieldConfig.optional && _vm.isBrigdeHasError,
      "success": _vm.bridgeHasValidParametersStrict,
      "type": _vm.fieldConfig.type === 'number' ? 'number' : _vm.fieldConfigStringField === 'password' && !_vm.showPassword ? 'password' : _vm.fieldConfigRequiresPermission === true && _vm.fieldConfigRequiredPermission === 'VirtualDeviceKey.read' && !_vm.hasVirtualDeviceKeyReaderPermission ? 'password' : 'text',
      "rules": _vm.rulesForField(_vm.fieldConfig),
      "hide-details": _vm.detailsMode,
      "disabled": _vm.disabled,
      "readonly": _vm.fieldConfig.readonly,
      "autocomplete": "off",
      "data-cy": `bridge_config_field_${_vm.configKey}`
    },
    on: {
      "input": _vm.modelChanged,
      "click:append": function ($event) {
        return _vm.textFieldClicked(true);
      },
      "click": function ($event) {
        return _vm.textFieldClicked();
      },
      "blur": function ($event) {
        return _vm.textFieldBlurred();
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [!_vm.bridgeHasValidParameters && !_vm.fieldConfig.optional && _vm.isBrigdeHasError ? [_c(VIcon, {
          staticClass: "pr-2",
          attrs: {
            "color": "danger"
          }
        }, [_vm._v("fal fa-exclamation-circle")])] : _vm.bridgeHasValidParametersStrict ? [_c(VIcon, {
          staticClass: "pr-2",
          attrs: {
            "color": "success"
          }
        }, [_vm._v("fal fa-check-circle")])] : [_c(VIcon, {
          class: `${_vm.defaultIcon ? 'pr-2' : ''}`
        }, [_vm._v(_vm._s(_vm.defaultIcon))])]];
      },
      proxy: true
    }, _vm.hasHelpText ? {
      key: "append-outer",
      fn: function () {
        return [_c(VIcon, {
          staticClass: "pl-0 ml-0",
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.openHelpText = true;
            }
          }
        }, [_vm._v("fal fa-question-circle")])];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.v,
      callback: function ($$v) {
        _vm.v = $$v;
      },
      expression: "v"
    }
  })]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };